import HttpRequest from '@/libs/axios'

// const baseUrl = 'http://192.168.200.13:8081/api'
const baseUrl = 'http://iot.rnpig.com/api'


const axios = new HttpRequest(baseUrl)

export default axios
